(function () {
  const comingSoonTimerEls = document.querySelectorAll('.coming-soon__timer');
  if (comingSoonTimerEls) {
    comingSoonTimerEls.forEach(comingSoonTimerEl => {
      const comingSoonTimerContainerEl = comingSoonTimerEl.closest('.coming-soon__countdown');
      const daysEl = comingSoonTimerEl.querySelector('[data-timer="days"]');
      const hoursEl = comingSoonTimerEl.querySelector('[data-timer="hours"]');
      const minutesEl = comingSoonTimerEl.querySelector('[data-timer="minutes"]');
      const secondsEl = comingSoonTimerEl.querySelector('[data-timer="seconds"]');
      const endedMessageEl = comingSoonTimerEl.querySelector('[data-timer="ended-message"]');
      const countDownDate = new Date(comingSoonTimerEl.dataset.endTime).getTime();

      const countDownInterval = setInterval(function () {
        const now = new Date().getTime();
        const timeDifference = countDownDate - now;

        // Update opcity to avoid layout shift
        if (comingSoonTimerContainerEl.style.opacity == "0") {
          comingSoonTimerContainerEl.style.opacity = "1";
        }

        // Time calculations for days, hours, minutes and seconds
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        // update count down elements
        if (days == 0) {
          daysEl.classList.add('hide'); 
        } else if (days >= 100) {
          daysEl.textContent = ("000" + days).slice(-3) + "d : ";
        } else {
          daysEl.textContent = ("00" + days).slice(-2) + "d : ";
        }

        hoursEl.textContent = ("00" + hours).slice(-2);
        minutesEl.textContent = ("00" + minutes).slice(-2);
        secondsEl.textContent = ("00" + seconds).slice(-2);

        // count down ended, show end message
        if (timeDifference < 0) {
          clearInterval(countDownInterval);
          const endedMessageVal = endedMessageEl.textContent;

          if (endedMessageVal.length != 0) {
            // if has a message, replace the content of this slide
            comingSoonTimerEl.closest('.coming-soon__countdown').textContent = endedMessageVal;
          } else {
            //only one coming-soon
            //document.querySelector(".coming-soon__countdown").classList.add('hide');
            comingSoonTimerContainerEl.style.opacity = "0";
          }
        }
      }, 1000);
    });
  }
})();
